"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.concentrationLimitPointerMethods = void 0;
/* eslint-disable no-param-reassign */
const lodash_1 = __importDefault(require("lodash"));
const calc_agent_1 = require("@finley-technologies/calc-agent");
const common_1 = require("@finley-technologies/common");
const getConcentrationLimitValue = (principalBalance) => {
    // 100% when the principalBalance < $4,000,000
    // 35% when the principalBalance >= $4,000,000
    // 30% when the principalBalance >= $8,000,000
    if (principalBalance < 4000000)
        return 1;
    if (principalBalance >= 8000000)
        return 0.3;
    return 0.35;
};
exports.concentrationLimitPointerMethods = [
    {
        method: 'vayaPier1.maximumPlatformConcentration',
        pointerImplementation: ({ concentrationReceivables, totalConcentrationExposure, }) => {
            (0, common_1.finleyAssert)(concentrationReceivables.length, new common_1.error.FinleyError(`expected concentrationReceivables to not be an empty array`));
            const { principalBalance, } = concentrationReceivables[0].dynamicIntermediateFields;
            (0, common_1.finleyAssert)(lodash_1.default.isNumber(principalBalance), new common_1.error.FinleyError(`expected principalBalance to be a number but got ${principalBalance}`));
            const concentrationLimit = getConcentrationLimitValue(principalBalance);
            const groupingId = 'platform';
            (0, common_1.finleyAssert)(lodash_1.default.every(concentrationReceivables, (rec) => lodash_1.default.isString(rec.baseFields[groupingId])), new common_1.error.FinleyError(`baseFields.${groupingId} must be defined to run vayaPier1.maximumPlatformConcentration`));
            const groupedByPlatform = lodash_1.default.groupBy(concentrationReceivables, (rec) => rec.baseFields[groupingId]);
            const standardBorrowingBaseReductions = lodash_1.default.map(lodash_1.default.entries(groupedByPlatform), ([, receivables]) => {
                return (0, calc_agent_1.calculateStandardConcentrationLimitKickouts)({
                    concentrationLimit,
                    totalConcentrationExposure,
                    concentrationReceivables: receivables,
                    concentrationLimitValueType: 'percentage',
                });
            });
            // accumulate all breaches into a single standard borrowing base reduction
            let concentrationAmount = 0;
            const concentrationKickouts = lodash_1.default.reduce(standardBorrowingBaseReductions, (result, { calculations, kickouts }) => {
                const _result = Object.assign({}, result);
                // add in concentrationAmount if over limit, cannot do in toPairs below since it will count the amount multiple times
                if (calculations.concentration > calculations.concentrationLimit) {
                    concentrationAmount += calculations.concentrationAmount || 0;
                }
                lodash_1.default.forEach(lodash_1.default.toPairs(kickouts), ([finleyReceivableId, kickout]) => {
                    if (kickout === 0)
                        return true;
                    if (!_result[finleyReceivableId]) {
                        _result[finleyReceivableId] = 0;
                    }
                    _result[finleyReceivableId] += kickout;
                    return true;
                });
                return _result;
            }, {});
            return {
                kickouts: concentrationKickouts,
                calculations: {
                    concentrationAmount,
                    concentrationLimit: standardBorrowingBaseReductions.length > 0
                        ? standardBorrowingBaseReductions[0].calculations
                            .concentrationLimit
                        : 0,
                    concentration: standardBorrowingBaseReductions.length > 0
                        ? standardBorrowingBaseReductions[0].calculations.concentration
                        : 0,
                },
            };
        },
    },
];
//# sourceMappingURL=concentrationLimitPointerMethods.js.map